import React from 'react';
import { ButtonFilled } from '../../../../components/ui';

interface EmptyStateProps {
  setActiveTab: (value: 'SETTINGS') => void;
}

const EmptyState: React.FC<EmptyStateProps> = ({ setActiveTab }) => {
  return (
    <div className="tc center mb2">
      <p className="f7 serif i lh-copy measure mv5 center">There’s no data for this group.</p>
      <div className="flex-ns w-100 mb4">
        <div className="w-50-ns tc ba b--light-gray br2 w-100 center mr1-ns mb2 mb0-ns">
          <div className="pa4">
            <p className="f5 fw6 mv2">Add Subjects & Trackers</p>
            <p className="f7 serif lh-copy measure-narrow mt0 mb4 center">
              Similar subjects can grouped together with common trackers.
            </p>
            <button
              className="dib f6 blue hover-navy mv2"
              onClick={() => setActiveTab('SETTINGS')}
            >
              Group Settings
            </button>
          </div>
        </div>
        <div className="w-50-ns tc ba b--light-gray br2 w-100 center ml1-ns">
          <div className="pa4">
            <p className="f5 fw6 mv2">Invite People</p>
            <p className="f7 serif lh-copy measure-narrow mt0 mb4 center">
              Collaborators can contribute data to this group.
            </p>
            <button
              className="dib f6 blue hover-navy mv2"
              onClick={() => setActiveTab('SETTINGS')}
            >
              Invite Collaborators
            </button>
          </div>
        </div>
      </div>
      <ButtonFilled onClick={() => setActiveTab('SETTINGS')}>Go to Settings</ButtonFilled>
    </div>
  );
};

export default EmptyState;
